import { IconProps } from './IconProps';

export const UHHomeFill = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="2.88025"
        width="16"
        height="7.04"
        rx="0.666667"
        fill={props.fill ?? '#000'}
      />
      <path
        d="M0 11.2586C0 11.0745 0.149238 10.9253 0.333333 10.9253H15.6667C15.8508 10.9253 16 11.0745 16 11.2586V11.6168C16 11.7012 15.968 11.7825 15.9104 11.8442L15.1153 12.6961C14.8632 12.9663 14.5102 13.1197 14.1406 13.1197H8H1.65423C1.21913 13.1197 0.811403 12.9074 0.561901 12.5509L0.0602502 11.8342C0.0210344 11.7782 0 11.7115 0 11.6431V11.2586Z"
        fill={props.fill ?? '#000'}
      />
    </svg>
  );
};
